var _g, _text, _text2, _path, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google_Play",
    "data-name": "Google Play",
    xmlns: "http://www.w3.org/2000/svg",
    width: 213,
    height: 64,
    viewBox: "0 0 213 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 203 63.5 L 10 63.5 C 4.761684417724609 63.5 0.5 59.23831558227539 0.5 54 L 0.5 10 C 0.5 4.761684417724609 4.761684417724609 0.5 10 0.5 L 203 0.5 C 208.2383117675781 0.5 212.5 4.761684417724609 212.5 10 L 212.5 54 C 212.5 59.23831558227539 208.2383117675781 63.5 203 63.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 1 C 5.037384033203125 1 1 5.037387847900391 1 10 L 1 54 C 1 58.96261215209961 5.037384033203125 63 10 63 L 203 63 C 207.9626159667969 63 212 58.96261215209961 212 54 L 212 10 C 212 5.037387847900391 207.9626159667969 1 203 1 L 10 1 M 10 0 L 203 0 C 208.5228271484375 0 213 4.477165222167969 213 10 L 213 54 C 213 59.52283477783203 208.5228271484375 64 203 64 L 10 64 C 4.4771728515625 64 0 59.52283477783203 0 54 L 0 10 C 0 4.477165222167969 4.4771728515625 0 10 0 Z",
    stroke: "none",
    fill: "#979797"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Download_on",
    "data-name": "Download on",
    transform: "translate(68.928 26)",
    fill: "#545454",
    fontSize: 15,
    fontFamily: "Roboto-Regular, Roboto",
    letterSpacing: "0.08em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download on"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "play",
    transform: "translate(136 48)",
    fill: "#545454",
    fontSize: 20,
    fontFamily: "Roboto-Light, Roboto",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "play"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo",
    d: "M0,37.264V2.74A3.047,3.047,0,0,1,1.712,0l19.97,20L1.7,40A3.046,3.046,0,0,1,0,37.264ZM23.4,21.719l4.614,4.621L6.182,38.963ZM25.124,20,30.2,14.918,34.8,17.582a3.048,3.048,0,0,1,.033,4.815L30.2,25.079ZM6.195,1.042l21.82,12.614L23.4,18.273Z",
    transform: "translate(16 12)",
    fill: "#4ca07a"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "Google",
    transform: "translate(68 49)",
    fill: "#545454",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Google"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/Google-Play.11a4be263daf4522d808442b094b2545.svg";
export { ForwardRef as ReactComponent };